export const patternSku = '[a-zA-Z0-9\\(\\)._,*+\\/\\-\\s]*';